import React from 'react';
import { Link } from 'react-router-dom';

export function SiteHeader() {
  return (
    <header className="site-header">
      <div className="container site-header-inner">
        <Link to="/" className="wordmark">Code That Down</Link>
        <a href="mailto:contact@codethatdown.com" className="header-link">Contact</a>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container site-footer-inner">
        <p>&copy; {new Date().getFullYear()} Code That Down LLC · Atlanta, Georgia</p>
        <nav aria-label="Legal">
          <Link to="/policy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </div>
    </footer>
  );
}
